import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-15d9c7ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-rapport" }
const _hoisted_2 = { class: "p-d-flex p-jc-center p-ai-center ticket-container" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { id: "print-rapport" }
const _hoisted_5 = { id: "header" }
const _hoisted_6 = {
  key: 0,
  id: "logo"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { id: "name" }
const _hoisted_9 = {
  key: 1,
  id: "desc"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_11 = { id: "ticket" }
const _hoisted_12 = { colspan: "2" }
const _hoisted_13 = { class: "p-text-left" }
const _hoisted_14 = { class: "p-text-left" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_16 = { id: "content" }
const _hoisted_17 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_18 = { colspan: "3" }
const _hoisted_19 = { colspan: "2" }
const _hoisted_20 = { class: "p-text-uppercase" }
const _hoisted_21 = { colspan: "2" }
const _hoisted_22 = { class: "p-text-uppercase" }
const _hoisted_23 = { colspan: "2" }
const _hoisted_24 = { class: "p-text-uppercase" }
const _hoisted_25 = { colspan: "2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_27 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_28 = { colspan: "3" }
const _hoisted_29 = { class: "p-text-uppercase" }
const _hoisted_30 = { colspan: "2" }
const _hoisted_31 = { class: "p-text-uppercase" }
const _hoisted_32 = { colspan: "2" }
const _hoisted_33 = { class: "p-text-uppercase" }
const _hoisted_34 = {
  colspan: "2",
  style: {"font-weight":"bolder"}
}
const _hoisted_35 = { class: "p-text-uppercase" }
const _hoisted_36 = {
  colspan: "2",
  style: {"font-weight":"bolder"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_38 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_39 = { colspan: "2" }
const _hoisted_40 = {
  style: {"margin-top":"3mm"},
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_41 = { colspan: "3" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_44 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_45 = { colspan: "3" }
const _hoisted_46 = { class: "p-text-uppercase" }
const _hoisted_47 = { colspan: "2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_49 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_50 = { colspan: "2" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "- Crédits", -1))
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "+ Paiments crédits en espèces", -1))
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "- Paiements externes", -1))
const _hoisted_58 = { key: 4 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "SOLDE ESPECES", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1))
const _hoisted_61 = { id: "footer" }
const _hoisted_62 = {
  key: 1,
  style: {"height":"100%"},
  class: "p-d-flex p-jc-center p-ai-center"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "200",
  src: "/empty_data.svg"
}, null, -1))
const _hoisted_64 = [
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_CategoryName = _resolveComponent("CategoryName")!
  const _component_ProductName = _resolveComponent("ProductName")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.seq = _ctx.sequence || _ctx.result?.sequenceGet))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.activeActivity.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: _ctx.activityLogo,
                          style: {"max-width":"50mm"},
                          alt: "locaa"
                        }, null, 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.activeActivity.name), 1),
                  (_ctx.activeActivity.slogan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.activeActivity.slogan), 1))
                    : _createCommentVNode("", true),
                  _hoisted_10,
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_12, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.seq.terminal.name), 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.seq.terminal.description), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("pos.sequence")), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_NumberFormatter, {
                          value: _ctx.seq.number
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.openedAt")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.seq.openedAt, _ctx.$t("format.ticketDate"))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.by")), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seq.opener.name), 1)
                    ]),
                    (_ctx.seq.closedAt)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.closedAt")), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.seq.closedAt, _ctx.$t("format.ticketDate"))), 1)
                          ]),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t("rapport.by")), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.seq.closer.name), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("product.categories")), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("product.label")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("pos.amount")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rapport.sequenceCategoriesRapport, (cat, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_CategoryName, {
                              category: { label: cat.category }
                            }, {
                              default: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(name), 1)
                              ]),
                              _: 2
                            }, 1032, ["category"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: cat.inclTax
                            }, null, 8, ["value"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      (_ctx.resume.discount || _ctx.resume.offer)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.amount")), 1),
                              _createElementVNode("th", _hoisted_19, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.category
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t("payment.discount")), 1),
                              _createElementVNode("th", _hoisted_21, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.discount
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t("rapport.offered")), 1),
                              _createElementVNode("th", _hoisted_23, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.offer
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("rapport.netTotal")), 1),
                        _createElementVNode("th", _hoisted_25, [
                          _createVNode(_component_NumberFormatter, {
                            value: 
                          _ctx.resume.category - _ctx.resume.discount - _ctx.resume.offer
                        
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_26,
                  _createElementVNode("table", _hoisted_27, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("pos.product")), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("product.article")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.quantity")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("pos.amount")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rapport.sequenceProductsRapport, (prod, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_ProductName, {
                              product: { name: prod.product }
                            }, {
                              default: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(name), 1)
                              ]),
                              _: 2
                            }, 1032, ["product"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: prod.quantity
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: prod.inclTax
                            }, null, 8, ["value"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      (_ctx.resume.discount || _ctx.resume.offer)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.$t("rapport.amount")), 1),
                              _createElementVNode("th", _hoisted_30, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.product
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$t("payment.discount")), 1),
                              _createElementVNode("th", _hoisted_32, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.discount
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$t("rapport.offered")), 1),
                              _createElementVNode("th", _hoisted_34, [
                                _createVNode(_component_NumberFormatter, {
                                  value: _ctx.resume.offer
                                }, null, 8, ["value"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.$t("rapport.netTotal")), 1),
                        _createElementVNode("th", _hoisted_36, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.product - _ctx.resume.discount - _ctx.resume.offer
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_37,
                  _createElementVNode("table", _hoisted_38, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t("pos.credit")), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.client")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.amount")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rapport.sequenceCreditsRapport, (credit, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(credit.customerName), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: credit.amount - credit.discount
                            }, null, 8, ["value"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.total")), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.creditsTotal
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_40, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.$t("pos.creditsPayments")), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("rapport.client")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.payed")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.remain")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resume.specialPayments, (credit, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(credit.customer), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: credit.amount
                            }, null, 8, ["value"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: credit.sold
                            }, null, 8, ["value"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.total")), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.creditPayments
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.resume.specialPayments.length > 0)
                            ? (_openBlock(), _createBlock(_component_NumberFormatter, {
                                key: 0,
                                value: _ctx.resume.credits
                              }, null, 8, ["value"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_42, "0")),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_43,
                  _createElementVNode("table", _hoisted_44, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t("pos.cancelling")), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("product.article")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.quantity")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("pos.amount")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rapport.sequenceTicketsBackRapport, (prod, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(prod.product), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: prod.quantity
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_NumberFormatter, {
                              value: prod.inclTax
                            }, null, 8, ["value"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.$t("payment.total")), 1),
                        _createElementVNode("td", _hoisted_47, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.back
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_48,
                  _createElementVNode("table", _hoisted_49, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("ticket.box")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, "= " + _toDisplayString(_ctx.$t("ticket.sales")), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.total
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ]),
                      (_ctx.resume.creditsTotal)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("td", null, [
                              _createVNode(_component_NumberFormatter, {
                                value: _ctx.resume.creditsTotal
                              }, null, 8, ["value"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.resume.creditPaymentSpecies)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("td", null, [
                              _createVNode(_component_NumberFormatter, {
                                value: _ctx.resume.creditPaymentSpecies
                              }, null, 8, ["value"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.resume.discount)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                            _createElementVNode("td", null, "- " + _toDisplayString(_ctx.$t("payment.discount")), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_NumberFormatter, {
                                value: _ctx.resume.discount
                              }, null, 8, ["value"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resume.paymentsByTypes, (pay, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (pay.amount)
                            ? (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, "- " + _toDisplayString(_ctx.$tm("payment.methods")[pay.type]), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_NumberFormatter, {
                                    value: pay.amount
                                  }, null, 8, ["value"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      (_ctx.resume.otherPayments)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("td", null, [
                              _createVNode(_component_NumberFormatter, {
                                value: _ctx.resume.otherPayments
                              }, null, 8, ["value"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.rapport.sequenceExpenseRapport)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [
                            _createElementVNode("td", null, "- " + _toDisplayString(_ctx.$t("pos.expense")), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_NumberFormatter, {
                                value: _ctx.rapport.sequenceExpenseRapport
                              }, null, 8, ["value"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_59,
                        _createElementVNode("th", null, [
                          _createVNode(_component_NumberFormatter, {
                            value: _ctx.resume.sold
                          }, null, 8, ["value"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t("rapport.rapportOf")) + " " + _toDisplayString(_ctx.formatDate(Date.now(), _ctx.$t("format.ticketDate"))), 1)
              ])
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
  ]))
}